import React from "react";

const VideoModal = ({ show, onClose, videoId }) => {
    if (!show) return null; // If not visible, return null

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
            <button
                className="absolute top-4 right-4 text-white text-2xl font-bold z-50"
                onClick={onClose}
            >
                &times;
            </button>
            <div className="bg-white rounded-lg max-w-3xl w-full relative">
                <div className="relative w-full aspect-video">
                    <iframe
                        className="w-full h-full rounded-lg"
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default VideoModal;
